<template>
  <div style="margin-bottom:56px;" class="hidden-sm-and-up">
    <div class="mobile_nav_wrap hidden-sm-and-up">
      <div class="navbar_left" @click="gobackHome">
        <img src="@/assets/img/home/logo.svg" />
      </div>
      <div class="navbar_right">
        <div class="nav_tiyan" @click="callPhone"><img src="@/assets/img/home/phone-w.svg">400-033-9003</div>
      </div>
    </div>
<!--    <Affix>-->
<!--    </Affix>-->
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuShow: false,
      centerShow: false,
      fireShow: false,
    }
  },
  props: {
    currentActive: {
      default: 0,
      type: Number,
    },
  },
  mounted() {
    this.stopBodyScroll(false)
  },
  methods: {


    stopBodyScroll (isFixed) {
      let bodyEl = document.body;
      let top = 0;
  if (isFixed) {
    top = window.scrollY

    bodyEl.style.position = 'fixed'
    bodyEl.style.top = -top + 'px'
  } else {
    bodyEl.style.position = ''
    bodyEl.style.top = ''

    window.scrollTo(0, top) // 回到原先的top
  }
},
    callPhone () {
      window.location.href = 'tel://' + 4000339003
    },
    moveMenu() {
      this.menuShow = !this.menuShow
      if (this.menuShow) {
        this.$refs.menu.style.top = '56PX'
        this.stopBodyScroll(true)
      } else {
        this.stopBodyScroll(false)
        this.$refs.menu.style.top = '-1000PX'
      }
    },
    changeCenterShow() {
      this.centerShow = !this.centerShow
      this.fireShow = false
    },
    changefireShow() {
      this.fireShow = !this.fireShow
      this.centerShow = false
    },
    gotoExperience() {
      this.menuShow = false
      this.$router.push('/Experience').catch((v) => {})
    },
    gobackHome(){
      this.menuShow = false
      this.stopBodyScroll(false)
      this.$router.push('/').catch((v) => {})

    }
  },
}
</script>

<style lang="scss" scoped>
.mobile_nav_wrap {
  box-sizing: border-box;
  width: 100%;
  height: 56PX;
  background: #000;
  z-index: 1000;
  display: flex;
  padding: 15PX 0 15PX 15PX;
  align-items: center;
  position: fixed;
  top: 0;
  //border-width: 0 0 1PX 0;
  //border-style: solid;
  //border-color: #C5C8D1;
  box-shadow: 8px 0px 14px  rgba(0,0,0,.1);
  .navbar_left {
    flex: 1;
    background: #000;
    img {
      width: 80%;
    }
  }
  .navbar_right {
    flex: 2;
    height: 56PX;
    display: flex;
    justify-content: flex-end;
    //background: #fff;
    .nav_tiyan {
      width: 140PX;
      height: 100%;
      //background: #fff;
      color:#fff;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16PX;
      font-weight: bold;
      margin-right: 10PX;
      img{
        width: 20PX;
        margin-right: 4PX;
      }
    }

    .nav_btns {
      width: 56PX;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      img{
        width: 30PX;
      }
    }
  }
}
.active{
  color: #0052D9 !important;
  font-weight: bold;
  background-color: #F5F7FA !important;
  .line{
    border-left: 3PX solid #0052D9 !important;
  }

}
.nav_menu{
  position: fixed;
  width: 100%;
  height: 100%;
  //height: 450PX;
  overflow: auto;
  list-style: none;
  left: 0;
  right: 0;
  top: -1000PX;
  padding-bottom: 57PX;
  box-sizing: border-box;
  background: rgba(0,0,0,.3);;
  box-shadow: 8px 0px 14px  rgba(0,0,0,.1);
  z-index: 9999;
  transition: all 0.2s;

  .menu_item{
    width: 100%;
    height: 50PX;
    font-size: 16PX;
    background: #fff;
    color: #1c212d;
    padding: 20PX 0;
    display: flex;
    align-items: center;
    border-bottom: 1PX solid #efefef;
    .line{
      padding-left: 10PX;
      width: 100%;
    }

  }

  .item_options{
    width: 100%;
    padding: 5PX 10PX;
    //height: 150PX;
    overflow-y: auto;
    font-size: 14PX;
    background: #fff;
    .sub-options{
      height: 40PX;
      line-height: 40PX;
      border-bottom: 1PX solid #efefef;
      padding-left: 20PX;
      a{
        //display: inline-block;
        width: 100%;
        color: #05102F;
        height: 25%;
        //padding: 20px 30PX;
        &:checked{
          color: #0052D9;
          font-weight: bold;
        }
      }
    }


  }
}
.zhankai{
  float: right;
  width: 20PX;
  font-size: 16PX;
  margin-top: -36PX;
  margin-right: 20PX;
  z-index: 9999;
  position: relative;
}
.guanbi{
  float: right;
  width: 20PX;
  font-size: 16PX;
  margin-top: -36PX;margin-right: 20PX;

  z-index: 9999;
  position: relative;
}
</style>